import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { NavHashLink as NavLink } from 'react-router-hash-link';

import './mobileMenu.css';

class mobileMenu extends Component {
  render() {
    return (
      <div className="mobile_menu_wrpr">
        <div className="mobile_menu">
          <div
            className="mobile_nav_opnr"
            onClick={() => {
              this.props.toggleMobileMenu();
            }}
          />
          <div className="nav_wrpr">
            <div className="mn_wrpr">
              <NavLink
                className="tlg nav_sec"
                smooth
                to="/#home"
                activeClassName="selected"
                onClick={this.props.hide}
              >
                Home
              </NavLink>
            </div>
            <div className="mn_wrpr">
              {' '}
              <NavLink
                className="tlg nav_sec"
                smooth
                to="/#about-us"
                activeClassName="selected"
                onClick={this.props.hide}
              >
                About
              </NavLink>
            </div>

            <div className="mn_wrpr">
              {' '}
              <NavLink
                className="tlg nav_sec"
                smooth
                to="/#services"
                activeClassName="selected"
                onClick={this.props.hide}
              >
                Services
              </NavLink>
            </div>

            <div className="mn_wrpr">
              {' '}
              <NavLink
                className="tlg nav_sec"
                smooth
                to="/#process"
                activeClassName="selected"
                onClick={this.props.hide}
              >
                Process
              </NavLink>
            </div>

            <div className="mn_wrpr">
              {/* <NavLink
                className="tlg nav_sec"
                smooth
                to="/#work"
                activeClassName="selected"
                onClick={this.props.hide}
              >
                Work
              </NavLink> */}
              <Link className="tlg nav_sec" smooth to="/portfolio">
                Work
              </Link>
            </div>

            <div className="mn_wrpr">
              <NavLink
                className="tlg nav_sec"
                smooth
                to="/#contact"
                onClick={this.props.hide}
                activeClassName="selected"
              >
                Contact
              </NavLink>
            </div>
          </div>
        </div>
        <div className="backdrop" onClick={this.props.hide} />
      </div>
    );
  }
}

export default mobileMenu;



// WEBPACK FOOTER //
// ./src/components/mobile-menu/mobileMenu.js